export const supportsWebp = async () => {
  return new Promise<boolean>((resolve) => {
    const image = new Image();
    image.addEventListener(
      'error',
      function resolveValue() {
        resolve(false);
      },
      { once: true },
    );
    image.addEventListener(
      'load',
      function resolveValue() {
        resolve(image.width === 1);
      },
      { once: true },
    );
    image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
  }).catch(() => {
    return false;
  });
};
